module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Ke-La.b8556f39.png";